import { render } from "./village_master.vue?vue&type=template&id=5591260f&scoped=true"
import script from "./village_master.vue?vue&type=script&lang=js"
export * from "./village_master.vue?vue&type=script&lang=js"

import "./village_master.vue?vue&type=style&index=0&id=5591260f&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\TRAVEL SAFE\\kite-app-api\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5591260f"]])

export default __exports__